module.exports = __webpack_public_path__ + "static/media/transmission-fluid-exchange-red.119dcf9a.svg";